<template>
  <div class="summary-item">
    <div class="summary-item__highlight col-lg-8 offset-lg-4">
      Total:
      <span v-if="orders.length">{{ total | currency }}</span>
      <span v-else>{{ "0.00" | currency }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    orders: {
      type: Array,
      default: () => []
    }
  },
  filters: {
    currency(val) {
      return "P " + val;
    }
  },
  computed: {
    total() {
      return this.orders
        .map(order => order.OrderPackage.total * order.OrderPackage.quantity)
        .reduce((accumulator, num) => accumulator + num)
        .toLocaleString("en-US", { minimumFractionDigits: 2 });
    }
  }
};
</script>

<style lang="scss" scoped>
.summary {
  &-item {
    display: flex;
    flex-wrap: wrap;
    margin: 20px 0px;
    &__highlight {
      background: #e6f3f4;
      font-size: 16px;
      font-weight: 500;
      line-height: 24px;
      padding: 15px 20px;
      text-align: right;
      width: 100%;
    }
  }
}
</style>
